import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import TabRow from './tabRow';
import { getCustomViews, deleteCustomView, hideTap } from '../../actions/marketsActions';
import { showGridViewPopup, showUpdateGridViewPopup } from '../../actions/customViewsActions';
import { CustomViewType } from '../../constants/customViews';
import { getOrderedGridViews } from '../../selectors/customViewsSelectors';
import { getIsPageVisible } from '../../selectors/mainSelectors';

class ManageTabs extends React.Component {
    componentDidMount() {
        this.props.getCustomViews();
    }

    handleCreateClick = () => {
        this.props.showGridViewPopup('create');
    };

    handleDeleteClick = id => {
        this.props.deleteCustomView(id, CustomViewType.GRID);
    };

    handleUpdateClick = id => {
        this.props.showUpdateGridViewPopup(id);
    };

    handleHideClick = (id, isHidden) => {
        this.props.hideTap(id, isHidden);
    };

    render() {
        const { customViews, isVisible } = this.props;

        if (!isVisible) {
            return null;
        }

        return (
            <div>
                <h1>MANAGE TABS</h1>
                <div className="manage-taps-container">
                    {customViews && customViews.length
                        ? customViews.map(item => (
                              <TabRow
                                  key={`key_${item.id}`}
                                  id={item.id}
                                  name={item.name}
                                  isHidden={item.hidden}
                                  deleteView={this.handleDeleteClick}
                                  updateView={this.handleUpdateClick}
                                  updateVisibility={this.handleHideClick}
                              />
                          ))
                        : null}
                    <div onClick={this.handleCreateClick} className="manage-taps-create-row">
                        Create new tab
                    </div>
                </div>
            </div>
        );
    }
}

ManageTabs.propTypes = {
    showGridViewPopup: PropTypes.func.isRequired,
    getCustomViews: PropTypes.func.isRequired,
    deleteCustomView: PropTypes.func.isRequired,
    hideTap: PropTypes.func.isRequired,
    showUpdateGridViewPopup: PropTypes.func.isRequired,
    customViews: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    isVisible: PropTypes.bool.isRequired,
};

export default connect(
    state => ({
        isVisible: getIsPageVisible(state),
        customViews: getOrderedGridViews(state),
    }),
    dispatch => ({
        ...bindActionCreators(
            { getCustomViews, deleteCustomView, showGridViewPopup, showUpdateGridViewPopup, hideTap },
            dispatch,
        ),
    }),
)(ManageTabs);



// WEBPACK FOOTER //
// ./source/screens/manageTabs/index.js